export default {
    routerName: 'ホームページ',
    card: {
        user: 'ユーザー数',
        ad: '広告数',
        article: '文章数',
        articleHits: '文章閲覧量(先週)',
        picture: '画像数',
        pictureHits: '画像閲覧量(先週)',
        tag:'タグ',
        journal:'刊物',
    },
    adCount: '広告作成数配列',
    articleCreateCount: '文章作成数(先週)',
    adAccessFrom: '広告のアクセス',
    userActiveDegree: '毎週ユーザーの活躍量',
    region: {
        hokaido: '北海道',
        touhoku: '東北',
        kanntou: '関東',
        tyubu: '中部',
        kinki: '近畿',
        tyugoku: '中国',
        sikoku: '四国',
        kyuusyuu: '九州',
        okinawaken: '沖縄',
        kaigai: '海外',
    },
    log: {
        accessLog: 'アクセスログ',
        operLog: '操作ログ',
        normal: '正常',
        error: '異常',
        total: '総量',
    },
    date: {
        mon: '月曜日',
        tue: '火曜日',
        wed: '水曜日',
        thu: '木曜日',
        fri: '金曜日',
        sat: '土曜日',
        sun: '日曜日',
    },
    systemInfo: {
        systemName: '系统名称',
        systemVersion: '版本信息',
        osName: '操作系统',
        osVersion: '系统版本',
        osArch: '系统架构',
        cpuCoreCount: 'CPU核数',
        memoryTotal: '系统内存',
        memoryFree: '剩余内存',
        memoryUsedPercent: '内存使用',
        localeLanguage: '系统语言',
        jvmName: 'JVM信息',
        jvmVersion: 'JVM版本',
        jvmHome: 'JAVA_HOME ',
        userDir: '工作目录  ',
        jvmTotalMemory: 'JVM占用内存',
        jvmFreeMemory: 'JVM空闲内存',
        jvmMaxMemory: 'JVM最大内存',
        userName: '当前用户',
        cpuCombinedPercent: 'CPU负载',
        zone: '系统时区',
    },
};
